import { CommonModule, Location } from '@angular/common'
import { Component, inject, signal, Signal } from '@angular/core'
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { FooterButtonsComponent, LoadingPageComponent } from '@monorepo-channels/components/ui-pm'
import { DivisorUiComponent } from '@monorepo-channels/components/ui-common'
import { MatIconModule } from '@angular/material/icon'
import { RouterLink } from '@angular/router'
import { getClient } from '@monorepo-channels/channels/domain'
import { Store } from '@ngrx/store'
import { SuggestRestaurantService } from '@monorepo-channels/shared/util-helpers'

interface FieldState {
	focused: Signal<boolean>
	editing: Signal<boolean>
	setFocused: (value: boolean) => void
	setEditing: (value: boolean) => void
}

@Component({
	standalone: true,
	imports: [
		CommonModule,
		FooterButtonsComponent,
		ReactiveFormsModule,
		FormsModule,
		MatButtonModule,
		DivisorUiComponent,
		MatIconModule,
		RouterLink,
		LoadingPageComponent,
	],
	selector: 'feature-pm-suggest-a-restaurant',
	templateUrl: './suggest-a-restaurant.component.html',
	styleUrls: ['./suggest-a-restaurant.component.scss'],
})
export class SuggestRestaurantComponent {
	private fb = inject(FormBuilder)
	private store = inject(Store)
	private suggestRestaurantService = inject(SuggestRestaurantService)
	private location = inject(Location)

	fieldStates = new Map<string, FieldState>()
	client$ = this.store.select(getClient)

	acceptedTerms = false
	isOrderSuccess = false
	isLoading = false

	formControl = this.fb.nonNullable.group({
		name: [{ value: '', disabled: false }, Validators.required],
		website: [{ value: '', disabled: false }, Validators.required],
	})

	constructor() {
		;['name', 'website'].forEach(fieldName => this.initializeFieldState(fieldName))
	}

	private initializeFieldState(fieldName: string) {
		const focused = signal(false)
		const editing = signal(false)

		this.fieldStates.set(fieldName, {
			focused,
			editing,
			setFocused: (value: boolean) => focused.set(value),
			setEditing: (value: boolean) => editing.set(value),
		})
	}

	getFieldState(fieldName: string): FieldState {
		return this.fieldStates.get(fieldName)!
	}

	goBack() {
		this.location.back()
	}

	submitSuggestion() {
		if (this.formControl.invalid || !this.acceptedTerms) {
			return
		}

		this.isLoading = true

		this.client$.subscribe({
			next: client => {
				if (!client) {
					console.error('Cliente não encontrado')
					this.isLoading = false
					return
				}

				const formValuesString = `
                <pre>
                    Origem: Programa Menu
                    Indicação do: Cliente
                    Nome: ${client.fullName}
                    Email: ${client.email}
                    Nome do Restaurante: ${this.formControl.value.name}
                    Website / Instagram: ${this.formControl.value.website}
                </pre>`

				this.suggestRestaurantService.sendEmail(formValuesString).subscribe({
					next: () => {
						this.isOrderSuccess = true
					},
					error: () => {
						console.error('Erro ao enviar sugestão por email')
					},
					complete: () => {
						this.isLoading = false
					},
				})
			},
			error: () => {
				console.error('Erro ao buscar cliente')
				this.isLoading = false
			},
		})
	}
}
